import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

/**
 * Compact enterprise page header for report library landing pages.
 */
export default function ReportPageHeader({
  icon: Icon,
  category,
  title,
  subtitle,
  breadcrumbCurrent,
}) {
  return (
    <header className="rpt-page-header">
      <div className="rpt-page-header__main">
        {Icon && (
          <div className="rpt-page-header__icon" aria-hidden="true">
            <Icon size={20} strokeWidth={2} />
          </div>
        )}
        <div className="rpt-page-header__text">
          {category && <span className="rpt-page-header__category">{category}</span>}
          <h1 className="rpt-page-header__title">{title}</h1>
          {subtitle && <p className="rpt-page-header__subtitle">{subtitle}</p>}
        </div>
      </div>
      <nav className="rpt-breadcrumb" aria-label="Breadcrumb">
        <Link to="/dashboard" className="rpt-breadcrumb__link">
          <Home size={12} strokeWidth={2.25} />
          <span>Home</span>
        </Link>
        <ChevronRight size={12} className="rpt-breadcrumb__sep" aria-hidden="true" />
        <span className="rpt-breadcrumb__muted">Reports</span>
        <ChevronRight size={12} className="rpt-breadcrumb__sep" aria-hidden="true" />
        <span className="rpt-breadcrumb__current">{breadcrumbCurrent || title}</span>
      </nav>
    </header>
  );
}
